import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import AddIcon from '@watershed/icons/components/Add';
import { TestIds } from '@watershed/shared-universal/utils/testUtils';
import SplitButtonDropdown from '@watershed/ui-core/components/SplitButtonDropdown';
import { useDialog } from '@watershed/ui-core/hooks/useDialog';

import { useUserCanCreateProject } from '../../utils/dataIngestionPermissionHooks';
import {
  HAS_ACCESS_TO_SDI_HISTORICAL_RESULTS,
  useAccessChecks,
} from '../../utils/featureAccess';
import { CreateIngestHistoricalResultsMeasurementProjectDialog } from '../measure/CreateIngestHistoricalResultsMeasurementProjectDialog';
import { useProjectCreationFlowState } from './utils/projectHelperHooks';

export default function FlexibleProjectPageActions() {
  // Gates the use of the SDI previous footprint button
  const orgPlanAllowsIngestHistorical = useAccessChecks(
    HAS_ACCESS_TO_SDI_HISTORICAL_RESULTS
  ).hasAccess;
  const canCreateProject = useUserCanCreateProject();
  const canImportProject = orgPlanAllowsIngestHistorical && canCreateProject;
  const showIngestHistoricalDataDialog = useDialog(
    CreateIngestHistoricalResultsMeasurementProjectDialog
  );

  const { openCreateFlow } = useProjectCreationFlowState();

  const items = [
    // First one gets exploded view, the rest in drop down!
    {
      id: 'create-project',
      label: (
        <Trans context="Measurement project primary button text">
          Create project
        </Trans>
      ),
      onSelect: openCreateFlow,
      disabled: !canCreateProject,
      tooltip: canCreateProject
        ? undefined
        : t`You do not have permission to create a project`,
      Icon: AddIcon,
      testId: TestIds.MeasurementProjectCreateButton,
    },
    {
      id: 'import-existing-footprint',
      label: <Trans>Import an existing footprint</Trans>,
      onSelect: showIngestHistoricalDataDialog,
      disabled: !canImportProject,
      tooltip: canImportProject
        ? undefined
        : t`You do not have permission to import an existing footprint`,
    },
  ];

  return (
    <SplitButtonDropdown
      items={items}
      data-testid={TestIds.ProjectsPageActions}
    />
  );
}
